import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { CaretLeft, CaretRight, MagnifyingGlass } from "phosphor-react";

import searchFetch from "../../redux/search/searchAction";
import Search from "../../components/search/index";
import CardShimmer from "../../components/search/card_shimmer";
import Breadcrumb from "../../components/breadcrumb/index";

const Index = () => {
  const [value, setValue] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const dispatch = useDispatch();
  const searchState = useSelector((state) => state.searchState);

  useEffect(() => {
    dispatch(searchFetch({ q: value, p: pageCount }));
  }, [value, dispatch, pageCount]);
  const changeHandler = (e) => {
    setValue(e.target.value);
  };
  const searchClick = () => {
    dispatch(searchFetch({ value }));
  };
  const NextClick = () => {
    setPageCount(pageCount + 1);
  };
  const PrevClick = () => {
    if (pageCount > 1) setPageCount(pageCount - 1);
  };
  let ArrS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  return (
    <>
      <div className="p-4 lg:px-24">
        <Breadcrumb />
        <div className="bg-slate-900 flex mb-6 p-3 lg:p-6 rounded-2xl space-x-3">
          <input
            id="large-input"
            type="text"
            name="search"
            value={value}
            onChange={changeHandler}
            placeholder="Search a movie, series..."
            className="block p-4 text-gray-900 rounded-lg sm:text-md outline-0 w-full"
          />
          <button
            onClick={searchClick}
            className="flex items-center justify-center p-4 bg-sky-500 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-sky-600"
          >
            <MagnifyingGlass size={24} />
          </button>
        </div>

        <div className="flex flex-col space-y-4 lg:space-y-0 lg:flex-row items-center lg:justify-between py-4">
          <div className="flex items-center space-x-2 text-3xl font-bold">
            <h1>Resualt</h1>
            {searchState?.movie?.metadata?.total_count ? (
              <h1>{searchState?.movie?.metadata?.total_count}</h1>
            ) : (
              <div className="animate-pulse bg-slate-200 h-6 w-16 rounded-lg"></div>
            )}
          </div>
          <div className="flex space-x-2 justify-center z-20 rounded-xl">
            <button
              disabled={
                searchState?.movie?.metadata?.current_page === "1" && true
              }
              onClick={PrevClick}
              className={`${
                searchState?.movie?.metadata?.current_page === "1" &&
                "disabled:opacity-50"
              } flex items-center justify-center p-3 bg-white text-slate-900 border border-slate-300 rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-100`}
            >
              <CaretLeft size={24} />
            </button>
            <p className="p-3">{pageCount}</p>
            <button
              onClick={NextClick}
              disabled={searchState?.movie?.metadata?.page_count <= 1 && true}
              className={`${
                searchState?.movie?.metadata?.page_count <= 1 &&
                "disabled:opacity-50"
              } flex items-center justify-center p-3 bg-slate-900 text-white rounded-xl transition-all duration-300 ease-in-out hover:bg-slate-800`}
            >
              <CaretRight size={24} />
            </button>
          </div>
        </div>

        {searchState.loading ? (
          <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
            {ArrS.map((index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        ) : searchState.error ? (
          <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
            {ArrS.map((index) => (
              <CardShimmer key={index} />
            ))}
          </div>
        ) : searchState.movie.data && searchState.movie.data.length > 0 ? (
          <div className="grid grid-cols-2 md:!grid-cols-4 lg:!grid-cols-5 gap-4">
            {searchState.movie.data.map((movie) => (
              <Search key={movie.id} data={movie} />
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center bg-slate-100 w-full h-96 rounded-xl">
            <h1>Not Found</h1>
          </div>
        )}
      </div>
    </>
  );
};

export default Index;
